import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SynonymsList from '@Pages/Heatmap/components/SynonymsList/SynonymsList';

import './TooltipContentTaxonomy.scss';

function TooltipContentTaxonomy({ label, subunits, synonyms }) {
  const isComplex = subunits && Object.keys(subunits)?.length > 1;
  const synonymsList = synonyms && synonyms[Object.keys(synonyms)?.[0]];
  const subUnitsList =
    subunits &&
    Object.keys(subunits)?.map((key) => ({
      key,
      title: subunits[key],
      synonyms: synonyms && synonyms[key],
    }));

  return (
    <div className="heatmap-tooltip-content-taxonomy">
      {!isComplex ? (
        <>
          <h5 className="heatmap-tooltip-content-taxonomy__heading">Name</h5>
          <div className="heatmap-tooltip-content-taxonomy__row">{label}</div>
          {synonyms && (
            <>
              <h5 className="heatmap-tooltip-content-taxonomy__heading">Synonyms</h5>
              <SynonymsList synonyms={synonymsList} className="heatmap-tooltip-content-taxonomy__row" />
            </>
          )}
        </>
      ) : (
        <ul className="heatmap-tooltip-content-taxonomy__subunits-list c-els-list els-bullet-list">
          {subUnitsList.map((subUnit) => (
            <li key={subUnit.key} className="heatmap-tooltip-content-taxonomy__subunits-list-item c-els-list__item">
              <div>{subUnit.title}</div>
              {subUnit.synonyms && (
                <SynonymsList
                  synonyms={subUnit.synonyms}
                  limit={2}
                  label={<span>Synonyms: </span>}
                  className="heatmap-tooltip-content-taxonomy__row"
                />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

TooltipContentTaxonomy.propTypes = {
  label: PropTypes.string,
  synonyms: PropTypes.object,
  subunits: PropTypes.object,
};

export default memo(TooltipContentTaxonomy);
